import React from "react";
import "./Menu.css";

import Category from "./Category";

export default function (props) {
  const { categories, menu, lang } = props;

  return (
    <div className="menu">
      <Category categories={categories} menu={menu} lang={lang} />
    </div>
  );
}
